import { Button } from '@material-ui/core';
import { CloudDownload } from '@material-ui/icons';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { finalResultsMinifiedType, useAppStateContext } from '../../AppStateProvider/AppStateProvider';
import { getFormattedDate } from '../../../utils';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const GeneratePDFButton = () => {
  const { finalResultsMinified } = useAppStateContext();

  const DownloadPDF = () => {
    const docDefinition = CreateDocDefinition(finalResultsMinified());
    const pdfDocGenerator = pdfMake.createPdf(docDefinition);
    pdfDocGenerator.download(`test-results${getFormattedDate()}.pdf`);
  };

  return (
    <div>
      <Button variant="contained" color="primary" startIcon={<CloudDownload />} onClick={DownloadPDF}>
        Download test results
      </Button>
    </div>
  );
};

export const CreateDocDefinition = (data: finalResultsMinifiedType) => {
  const networkTestReport = [
    `Expected Quality: ${data.preflightTestReport.callQuality}`,
    `Edge Location: ${data.preflightTestReport.edge}`,
    `Jitter: ${data.preflightTestReport.jitter}`,
    `Latency: ${data.preflightTestReport.latency}`,
    `Packet Loss: ${data.preflightTestReport.packetLoss}`,
  ];

  return {
    content: [
      { text: 'Test Result of ' + data.email, style: 'header' },
      { text: '\n' },
      {
        table: {
          widths: ['auto', '*'],
          body: [
            ['Date:', data.date],
            ['Email:', data.email],
            ['Browser Info:', `${data.browserInfo.name} ${data.browserInfo.version}`],
            ['OS:', `${data.operatingSystem.name}`],
            ['Input Device:', data.inputDevice],
            [
              'Connectivity:',
              {
                ul: [`Signaling Region: ${data.connectivity.signalingRegion}`],
              },
            ],
            [
              'Twilio Services:',
              {
                ul: [
                  `Voice REST API: ${data.twilioServices?.['Voice REST API US1'] ?? 'Not available'}`,
                  `Conference API: ${data.twilioServices?.['Conference US1'] ?? 'Not available'}`,
                  `Client Web API: ${data.twilioServices?.['Client Web US1'] ?? 'Not available'}`,
                  `Recording API: ${data.twilioServices?.['Recording US1'] ?? 'Not available'}`,
                ],
              },
            ],
            [
              'Notified Services:',
              {
                ul: [
                  `Booking API: ${data.conferencingServices?.bookingApiStatus ?? 'Not available'}`,
                  `Conference API: ${data.conferencingServices?.conferenceApiStatus ?? 'Not available'}`,
                  `Phone API: ${data.conferencingServices?.phoneNumberApiStatus ?? 'Not available'}`,
                ],
              },
            ],
            [
              'Network Test Report:',
              {
                ul: networkTestReport,
              },
            ],
          ],
        },
      },
    ],
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        alignment: 'left',
      },
    },
  };
};

export default GeneratePDFButton;
